import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../cn.js';
import { STATUS_GLYPH } from '../generated/status.js';
import { STATUS_LABEL } from '../status-signals.js';
import { StatusGlyph } from './icons.js';
/**
 * A status, said three ways at once (§02, principle 03).
 *
 * Colour, shape, word. The component gives no way to render fewer than all
 * three — there is no `iconOnly`, no bare dot, no colour-only variant — because
 * every screen in this product has to pass the grayscale test and the cheapest
 * way to guarantee that is to make the failing version unbuildable.
 */
const TONE_CLASS = {
    // Written out rather than interpolated: Tailwind reads source text, and a
    // class assembled at runtime is a class that never gets generated.
    verified: 'text-verified bg-verified-bg border-verified-br',
    scheduled: 'text-scheduled bg-scheduled-bg border-scheduled-br',
    progress: 'text-progress bg-progress-bg border-progress-br',
    warning: 'text-warning bg-warning-bg border-warning-br',
    critical: 'text-critical bg-critical-bg border-critical-br',
    inactive: 'text-inactive bg-inactive-bg border-inactive-br',
};
export function StatusPill({ tone, children, className, }) {
    return (_jsxs("span", { "data-tone": tone, className: cn('inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2 py-1', 
        // 10.5px, uppercase, tracked out — the reference's badge, and the same
        // treatment as the eyebrow, because they are the same kind of label.
        // The tracking rides on the `2xs` step rather than a class beside it.
        'text-2xs font-bold uppercase', TONE_CLASS[tone], className), children: [_jsx(StatusGlyph, { name: STATUS_GLYPH[tone], className: "h-3 w-3" }), children ?? STATUS_LABEL[tone]] }));
}
//# sourceMappingURL=pill.js.map